<template lang="pug">
  .icon-chevron-y.transform.origin-center(:class="{'-scale-y-100': up}")
    span.block.border-r.border-b.border-current(:style="{width: '0.8rem', height: '0.8rem', transform: 'rotate(45deg) translate(0, -0.2rem)', transformOrigin: 'center center'}")
</template>

<script>
export default {
  name: 'IconChevronY',
  props: ['up']
}
</script>

<style>
</style>
